/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateCreditRequestLogDto } from '../../models/create-credit-request-log-dto';
import { CreditRequestLogDto } from '../../models/credit-request-log-dto';

export interface CreditRequestLogControllerCreate$Params {
      body: CreateCreditRequestLogDto
}

export function creditRequestLogControllerCreate(http: HttpClient, rootUrl: string, params: CreditRequestLogControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CreditRequestLogDto>> {
  const rb = new RequestBuilder(rootUrl, creditRequestLogControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreditRequestLogDto>;
    })
  );
}

creditRequestLogControllerCreate.PATH = '/api/creditRequestLog';
